<template>
    <div class="lby-gossip-item" @click="rentInfo">
      <div class="lby-gossip-title"><span>战斗力:</span>{{rent.combatNumber}}</div>
      <div class="lby-gossip-title"><span>属性评分:</span>{{rent.attributeNumber}}亿</div>
      <div class="lby-gossip-title price"><span>月租价格:</span>{{rent.price}}￥</div>
      <div class="lby-gossip-title"><span>其他说明:</span>{{showOthers}}</div>
      <div class="lby-gossip-createTime">{{rent.updateTime}}</div>
    </div>
  </template>

<script>
export default {
  name: 'UCRent',
  props: {
    rent: {
      default: () => {
        return {}
      }
    },
    pageNo: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showOthers () {
      if (this.rent.others.length <= 50) {
        return this.rent.others
      }
      return this.rent.others.substring(0, 50) + '...'
    }
  },
  methods: {
    rentInfo () {
      this.$router.push({
        path: '/rentinfo',
        query: {
          rentId: this.rent.id,
          rentPageNo: this.pageNo
        }
      })
    }
  }
}
</script>

  <style scoped lang="less">
  .lby-gossip-item{
      width: 150px;
      height: 100%;
      border-radius: 10px;
      border: 1px solid #409eff;
      box-shadow: 0 0 4px rgb(53, 52, 52);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      padding-left: 5px;
      .lby-gossip-title{
          white-space: wrap;
          text-align: left;
          margin-top:10px;
          span{
            display: inline-block;
            width: 55px;
          }
      }
      .price{
        color:rgb(252, 52, 2);
      }
  }
  .lby-gossip-item:hover{
      border-color: red;
      cursor: pointer;
  }
  </style>
